import { render } from "./SetupView.vue?vue&type=template&id=56f49575"
import script from "./SetupView.vue?vue&type=script&lang=js"
export * from "./SetupView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__